<template>
	<div class="bootbox modal fade in show" tabindex="-1" role="dialog" style="display: block;">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-body">
					<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
					<div class="bootbox-body body-by-A4 " id="retreatReportPrint" ref="retreatReportPrint">
						<div class="report-title" style="text-align: center;">
							<h3> 亞東學校財團法人亞東科技大學退宿申請表 </h3>
						</div>
						<p></p>
						<div class="report-content">
							<p style="font-size:15px;">申請退宿人：</p>
							<table style="width:99%; text-align: center; font-size:10px;" class="table-bordered">
								<tr>
									<td style="width:18%;">姓名</td>
									<td style="width:18%;">學號</td>
									<td style="width:18%;">班級</td>
									<td style="width:18%;">住宿寢室</td>
									<td style="width:28%;">申請日期</td>
								</tr>
								<tr>
									<td>{{stuBase.name}}</td>
									<td>{{stuBase.account}}</td>
									<td>{{stuBase.drade}}年{{stuBase.dradeClass}}班</td>
									<td>{{dormitoryApply.bedFloor}}-{{dormitoryApply.bedRoom}}-{{dormitoryApply.bed}}-{{dormitoryApply.bedCategory}}</td>
									<td>{{customFormatter(dormitoryLeave.leaveDate)}}</td>
								</tr>
								<tr>
									<td>身分證字號</td>
									<td>存摺局號（本人）</td>
									<td>存摺帳號（本人）</td>
									<td>電話（手機）</td>
									<td>
										<span v-if="dormitoryApply.dormitoryType == 'N'">辦理就學貸款&emsp;{{dormitoryApply.isStuLoanStr}}</span>
									</td>
								</tr>
								<tr>
									<td>{{stuBase.idno}}</td>
									<td>{{stuBase.bankNo}}</td>
									<td>{{stuBase.bankAccount}}</td>
									<td>{{stuBase.phone}}</td>
									<td>
										<label> 是<input type="checkbox" disabled :value="true"> </label>
										<label> 否<input type="checkbox" disabled :value="false"> </label>
										附原繳費單
									</td>
								</tr>
							</table>
							<p></p>
							<div style="width:99%; border: 3px #ddd double;">
								<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">切結</p>
								<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">申請退宿原因：{{dormitoryLeave.leaveReasonStr}}</p>
								<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">退宿後居住地址：{{dormitoryLeave.liveCityStr}}{{dormitoryLeave.liveAreaStr}}{{dormitoryLeave.liveRoadStr}}{{dormitoryLeave.liveAddr}}</p>
								<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">&emsp;&emsp;學生申請自{{dormitoryLeave.leaveDateCht}}起，申請退宿。並保證遵守下列事項：</p>
								<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">一、	該學年度內不得再申請住校。</p>
								<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">二、	不得使用或占用宿舍寢室或床位。</p>
								<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">三、	個人物品於申請後，於三日內立即搬離，否則視同廢棄物處理。</p>
								<p style=" text-align:right; padding:0 20px 0 0;">申請退宿學生簽章：______________ &emsp;</p>
							</div>
							<p></p>
							<div style="width:95%; padding: 0 0 0 60px; margin: 0 !important;">
								<p>敬會：</p>
								<p style=" padding:0 0 0 20px; margin: 0 !important;">室(戶)長：</p>
								<p style=" padding:0 0 0 20px; margin: 0 !important;">宿舍自治幹部：</p>
								<hr style="border-top: 2px dotted #ddd; background-image: none; " />
								<p>就學貸款承辦人：</p>
							</div>
							<p></p>
							<table style="width:99%; height:120px; vertical-align: top; border-collapse: collapse; border: 1px solid #ddd;">
								<tr style="height:40px;">
									<td style="width:40%; border: 1px solid #ddd; ">已繳住宿費、預繳費及保證金金額</td>
									<td style="width:40%; text-align: right; border: 1px solid #ddd; ">新臺幣{{dormitoryApply.roomAmt + dormitoryApply.ensureAmt}}元整&emsp;</td>
									<td style="width:20%; border: 1px solid #ddd; " rowspan="3">
										<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">符合退費標準： {{leaveModel}}</p>


									</td>
								</tr>
								<tr style="height:40px;">
									<td style="border: 1px solid #ddd; ">申請退宿退費(含預繳費及保證金)</td>
									<td style="text-align: right; border: 1px solid #ddd; ">新臺幣{{dormitoryLeave.leaveAmt}}元整&emsp;</td>
								</tr>
								<tr style="height:40px;">
									<td style="border: 1px solid #ddd; ">核定退宿退費(含預繳費及保證金)</td>
									<td style="text-align: right; border: 1px solid #ddd; ">新臺幣{{dormitoryLeave.leaveAmt}}元整&emsp;</td>
								</tr>
							</table>
							<p></p>
							<table style="width:99%; vertical-align: top; border-collapse: collapse; border: 1px solid #ddd;  ">
								<tr>
									<td style="width:12%; border: 1px solid #ddd; ">承辦人</td>
									<td style="width:12%; border: 1px solid #ddd; ">生輔組</td>
									<td style="width:12%; border: 1px solid #ddd; ">學務長</td>
									<td style="width:12%; border: 1px solid #ddd; ">出納組</td>
									<td style="width:12%; border: 1px solid #ddd; ">會計室</td>
									<td style="width:12%; border: 1px solid #ddd; ">校長</td>
								</tr>
								<tr>
									<td style="line-height: 5; border: 1px solid #ddd;">&emsp;</td>
									<td style="line-height: 5; border: 1px solid #ddd;">&emsp;</td>
									<td style="line-height: 5; border: 1px solid #ddd;">&emsp;</td>
									<td style="line-height: 5; border: 1px solid #ddd;">&emsp;</td>
									<td style="line-height: 5; border: 1px solid #ddd;">&emsp;</td>
									<td style="line-height: 5; border: 1px solid #ddd;">&emsp;</td>
								</tr>
							</table>
						</div>
						<p></p>
						<div class="report-footer">
							<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">退費標準：依據學生宿住宿輔導及管理辦法第五條第四款第二項。</p>
							<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">（一）已完成登記繳費，尚未進住宿舍者，全額退費。</p>
							<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">（二）入宿後未逾一個月，退還二分之一費用。</p>
							<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">（三）入宿後逾一個月未逾兩個月，退還三分之一費用。</p>
							<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">（四）入宿後逾二個月退宿，不予退費。</p>
							<p style="margin: 0 !important;padding: 1px 0 3px 0 !important;">（五）因個人因素遭到學校退宿者，一律不予退費。</p>
						</div>
						<p></p>
					</div>
					<div class="text-center">
						<button @click="printReport()" class="no-print">列印</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { Printd } from 'printd'
export default {
	props: ['idno', 'account', "applyId"],
	data(){
		return{
			stuBase:{},
			dormitoryApply:{},
			dormitoryLeave:{},
			leaveModel:"",
		}
	},
	created(){
		const initParam = {
			id:this.applyId,
			account:this.account,
			idno:this.idno,
		}
		const _this = this;
		const api = "/api/Room/roomInfo";
		this.$axios.post(api, initParam).then(resp =>{
			if(resp.data.status == "success"){
				if("stuBase" in resp.data.data){
					this.stuBase = resp.data.data.stuBase;
				}
				if("dormitoryApply" in resp.data.data){
					this.dormitoryApply = resp.data.data.dormitoryApply;
					this.dormitoryLeave = this.dormitoryApply.tbDormitoryLeave;
					if(this.dormitoryLeave.leaveType == "C"){
						const intoDate = this.dormitoryApply.intoRoomDate ? new Date(this.dormitoryApply.intoRoomDate) : null ;
            			const leaveDate = this.dormitoryLeave.leaveDate ? new Date(this.dormitoryLeave.leaveDate) : null;
						let oneDate = new Date(intoDate);
						oneDate.setMonth(oneDate.getMonth() + 1);
						let twoDate = new Date(oneDate);
						twoDate.setMonth(twoDate.getMonth() + 1);
						if(intoDate > leaveDate || intoDate === null){
							this.leaveModel = "（一）";
						}else if(intoDate <= leaveDate && leaveDate < oneDate){
							this.leaveModel = "（二）";
						}else if(oneDate <= leaveDate && leaveDate < twoDate){
							this.leaveModel = "（三）";
						}else{
							this.leaveModel = "（四）";
						}
					}else{
						this.leaveAmt = 0 + this.dormitoryApply.ensureAmt;
					}
				}
			}
		});
	},
	methods:{
		closePopup() {
			this.$parent.showPopupControl(false);
		},
		printReport(){
			const d = new Printd();
			d.print(document.getElementById('retreatReportPrint'),[`
				.body-by-A4 p{line-height:1;}
				.body-by-A4 .table-bordered{border-collapse: collapse; border: 1px solid #ddd;}
				.body-by-A4 .table-bordered tr>td{ padding: 0; line-height: 1.5; vertical-align: top; border: 1px solid #ddd;  }
			`])
		}
	}
}
</script>
<style scoped>
@media (min-width: 800px){
	.modal-body{
		overflow-x:hidden;
	}
}
.modal-body{
	overflow-x:auto;
}
.body-by-A4{
	overflow-y:auto;
	height: 120mm;
	width: 210mm;
	margin:1cm;
}
.body-by-A4 .table-bordered{border-collapse: collapse; border: 1px solid #ddd;}
.body-by-A4 .table-bordered tr>td{ padding: 0; line-height: 1.5; vertical-align: top; border: 1px solid #ddd;  }
.body-by-A4 p{line-height:1;}
@media print {
    .body-by-A4 {
        width: 210mm;
        height: 267mm;
    }
	.no-print{
		display: none;
	}
    @page {
        size: A4;
        margin:0 !important;
		padding: 0 !important;
    }
}
</style>
